<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>角色信息维护</span>
      </div>
      <el-form
        ref="roleForm"
        :model="roleInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="100px"
      >
        <div class="add-form-item">
          <el-form-item label="角色名称：" prop="roleName">
            <el-input v-model="roleInfo.roleName"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入20个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="角色描述：" prop="description">
            <el-input v-model="roleInfo.description"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入50个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="权限列表：">
            <el-checkbox v-model="allChecked" @change="checkedAll"
              >全选</el-checkbox
            >
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-tree
            :data="menuTree"
            ref="menuTree"
            show-checkbox
            node-key="id"
            :check-strictly="true"
            :default-expand-all="true"
            :default-checked-keys="defaultCheckedKeys"
            :props="defaultProps"
            @check="getCurrentNode"
          >
          </el-tree>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      roleInfo: {
        roleName: "",
        description: ""
      },
      allChecked: false,
      rules: {
        roleName: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          },
          {
            max: 20,
            message: "最多输入20个字符",
            trigger: "change"
          }
        ],
        description: [
          {
            required: true,
            message: "请输入角色描述",
            trigger: "blur"
          },
          {
            max: 50,
            message: "最多输入50个字符",
            trigger: "change"
          }
        ]
      },
      menuTree: [],
      defaultProps: {
        children: "child",
        label: "menuName"
      },
      defaultCheckedKeys: []
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getRoleInfo(id) {
      let _this = this;
      let param = {
        url: "/api/role/getRoleInfoById",
        params: {
          id: id
        }
      };

      _this.$store.dispatch("getRoleInfoById", param).then(() => {
        _this.roleInfo.roleName = _this.$store.state.system.roleInfo.roleName;
        _this.roleInfo.description =
          _this.$store.state.system.roleInfo.description;
        _this.menuTree = _this.$store.state.system.menuTree;
        _this.defaultCheckedKeys = _this.$store.state.system.checkedKeys;
      });
    },
    //全选
    checkedAll() {
      let _this = this;
      if (_this.allChecked) {
        _this.$refs.menuTree.setCheckedNodes(_this.menuTree);
      } else {
        _this.$refs.menuTree.setCheckedNodes([]);
      }
    },
    getCurrentNode(data) {
      // console.log(data)
      let node = this.$refs.menuTree.getNode(data);
      this.childNodes(node);
      this.parentNodes(node);
    },
    //具体方法可以看element官网api
    childNodes(node) {
      let len = node.childNodes.length;
      for (let i = 0; i < len; i++) {
        node.childNodes[i].checked = node.checked;
        this.childNodes(node.childNodes[i]);
      }
    },
    parentNodes(node) {
      if (node.parent) {
        for (let key in node) {
          if (key === "parent") {
            node[key].checked = true;
            this.parentNodes(node[key]);
          }
        }
      }
    },
    submit() {
      let _this = this;
      _this.$refs.roleForm.validate(isPass => {
        if (isPass) {
          let checkedKeys = _this.$refs.menuTree.getCheckedNodes();
          let param = {
            url: "/api/role/updateRoleInfo",
            params: {
              checkedMenus: checkedKeys,
              id: _this.$route.params.id,
              roleName: _this.roleInfo.roleName,
              description: _this.roleInfo.description
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "角色信息维护成功",
                  type: "success"
                });
                this.$router.push({
                  name: "role"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善角色信息",
            type: "warning"
          });
        }
      });
    }
  },
  created() {
    let _this = this;
    let id = this.$route.params.id;
    if (id !== null && id !== "" && id !== undefined) {
      _this.getRoleInfo(id);
    }
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
